import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, ExternalLink } from 'lucide-react';
import { LogoMark } from './LogoMark';
import { getShopUrl } from '../data/shopUrls';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-900 text-white border-t border-white/5" data-id="element-104">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-12" data-id="element-105">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-106">
          {/* Column 1: Company Info */}
          <div data-id="element-107">
            <Link to="/" className="inline-block mb-6" data-id="element-108">
              <LogoMark size="md" variant="dark" data-id="element-109" />
            </Link>

            {/* Head Office */}
            <div className="mb-5" data-id="element-110">
              <span className="text-xs font-bold uppercase tracking-wider text-cg-orange-600 block mb-2" data-id="element-111">
                Head Office — United Kingdom
              </span>
              <div className="text-steel-400 text-sm space-y-1" data-id="element-112">
                <p data-id="element-113">Unit 12, Industrial Park</p>
                <p data-id="element-114">Hertfordshire, United Kingdom</p>
              </div>
              <div className="mt-2 flex items-center gap-2 text-steel-400 text-sm" data-id="element-115">
                <Phone className="w-3 h-3 text-steel-500 flex-shrink-0" data-id="element-116" />
                <span data-id="element-117">+44 (0) 1234 567890</span>
              </div>
            </div>

            {/* UAE Office */}
            <div className="mb-6 pt-4 border-t border-white/10" data-id="element-118">
              <span className="text-xs font-bold uppercase tracking-wider text-cg-orange-600 block mb-2" data-id="element-119">
                Regional Office — UAE
              </span>
              <div className="text-steel-400 text-sm space-y-1" data-id="element-120">
                <p data-id="element-121">1209 i-Rise Tower</p>
                <p data-id="element-122">Barsha Heights, Dubai, UAE</p>
              </div>
            </div>

            <a href={getShopUrl()} target="_blank" rel="noopener noreferrer" className="text-white hover:text-cg-orange-600 text-sm transition-colors font-bold flex items-center gap-2" data-id="element-123">
              Browse Inventory <ExternalLink className="w-3 h-3" data-id="element-124" />
            </a>
          </div>

          {/* Column 2: About Us */}
          <div data-id="element-125">
            <h3 className="text-sm font-bold uppercase tracking-wider text-cg-orange-600 mb-6" data-id="element-126">
              About Us
            </h3>
            <ul className="space-y-3" data-id="element-127">
              <li data-id="element-128">
                <Link to="/about/who-we-are" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-129">
                  Who We Are
                </Link>
              </li>
              <li data-id="element-130">
                <Link to="/about/what-we-do" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-131">
                  What We Do
                </Link>
              </li>
              <li data-id="element-132">
                <Link to="/about/certifications" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-133">
                  Certifications
                </Link>
              </li>
              <li data-id="element-134">
                <Link to="/about/news" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-135">
                  News & Insights
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Manufacturing */}
          <div data-id="element-136">
            <h3 className="text-sm font-bold uppercase tracking-wider text-cg-orange-600 mb-6" data-id="element-137">
              Manufacturing
            </h3>
            <ul className="space-y-3" data-id="element-138">
              <li data-id="element-139">
                <Link to="/manufacturing/markets" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-140">
                  Our Markets
                </Link>
              </li>
              <li data-id="element-141">
                <Link to="/manufacturing/processes" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-142">
                  Our Processes
                </Link>
              </li>
              <li data-id="element-143">
                <Link to="/manufacturing/defence-procurement" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-144">
                  Defence Procurement
                </Link>
              </li>
              <li data-id="element-145">
                <Link to="/manufacturing/frameworks" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-146">
                  Our Frameworks
                </Link>
              </li>
              <li data-id="element-147">
                <Link to="/manufacturing/catalogues" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-148">
                  Our Catalogues
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Legal & Contact */}
          <div data-id="element-149">
            <h3 className="text-sm font-bold uppercase tracking-wider text-cg-orange-600 mb-6" data-id="element-150">
              Support & Legal
            </h3>
            <ul className="space-y-3 mb-8" data-id="element-151">
              <li data-id="element-152">
                <Link to="/faqs" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-153">
                  FAQs
                </Link>
              </li>
              <li data-id="element-154">
                <Link to="/contact" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-155">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-156">
                <Link to="/supplier-network" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-157">
                  Supplier Network
                </Link>
              </li>
              <li data-id="element-158">
                <Link to="/privacy-policy" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-159">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-160">
                <Link to="/terms-of-service" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-161">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-162">
                <Link to="/cookie-policy" className="text-steel-400 hover:text-white text-sm transition-colors" data-id="element-163">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Office Locations — full-width row below main columns */}
        <div className="mt-12 pt-10 border-t border-white/10" data-id="element-164">
          <h3 className="text-sm font-bold uppercase tracking-wider text-cg-orange-600 mb-6" data-id="element-165">
            Office Locations
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8 max-w-2xl" data-id="element-166">
            {/* UK Office */}
            <div className="bg-navy-800 border border-white/10 p-5 rounded-sm" data-id="element-167">
              <div className="flex items-center gap-2 mb-3" data-id="element-168">
                <MapPin className="w-3.5 h-3.5 text-cg-orange-600 flex-shrink-0" data-id="element-169" />
                <span className="text-xs font-bold uppercase tracking-wider text-cg-orange-600" data-id="element-170">
                  United Kingdom
                </span>
              </div>
              <p className="text-white text-sm font-semibold mb-1" data-id="element-171">UK Office</p>
              <p className="text-steel-400 text-sm leading-relaxed" data-id="element-172">
                Unit 12, Industrial Park
                <br data-id="element-173" />
                Hertfordshire
                <br data-id="element-174" />
                United Kingdom
              </p>
              <div className="mt-3 flex items-center gap-2 text-steel-400 text-sm" data-id="element-175">
                <Phone className="w-3.5 h-3.5 text-steel-500 flex-shrink-0" data-id="element-176" />
                <span data-id="element-177">+44 (0) 1234 567890</span>
              </div>
            </div>

            {/* UAE Office */}
            <div className="bg-navy-800 border border-white/10 p-5 rounded-sm" data-id="element-178">
              <div className="flex items-center gap-2 mb-3" data-id="element-179">
                <MapPin className="w-3.5 h-3.5 text-cg-orange-600 flex-shrink-0" data-id="element-180" />
                <span className="text-xs font-bold uppercase tracking-wider text-cg-orange-600" data-id="element-181">
                  United Arab Emirates
                </span>
              </div>
              <p className="text-white text-sm font-semibold mb-1" data-id="element-182">
                UAE Office
              </p>
              <p className="text-steel-400 text-sm leading-relaxed" data-id="element-183">
                1209 i-Rise Tower
                <br data-id="element-184" />
                Barsha Heights, Dubai
                <br data-id="element-185" />
                United Arab Emirates
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/5 bg-navy-900" data-id="element-186">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-187">
          <p className="text-steel-500 text-xs" data-id="element-188">
            © Chiltern Global. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}